import React from 'react';
import {Box, Typography} from '@mui/material';
import {useNavigate} from 'react-router-dom';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';

function ProjectHeader({backgroundImage, projectName, role, duration}) {
    const navigate = useNavigate();

    return (
        <Box sx={{position: 'relative', width: '100%'}}>
            <Box
                sx={{
                    width: '100%',
                    height: {xs: '240px', sm: '360px', md: '460px'},
                    backgroundImage: `url(${backgroundImage})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                    display: 'flex',
                    alignItems: 'flex-end',
                    justifyContent: 'flex-start',
                }}
            >
                <Box sx={{
                    background: 'rgba(0,0,0,0.45)',
                    width: '100%',
                    padding: {xs: '16px 24px', md: '32px 64px'},
                    display: 'flex',
                    flexDirection: {xs: 'column', sm: 'row'},
                    alignItems: {xs: 'flex-start', sm: 'flex-end'},
                    justifyContent: 'space-between',
                    gap: '8px',
                }}>
                    <Typography variant="h3" fontWeight="bold" color="white">
                        {projectName}
                    </Typography>
                    <Box sx={{display: 'flex', gap: '32px'}}>
                        {role && (
                            <Box>
                                <Typography variant="caption" color="rgba(255,255,255,0.7)" display="block">Role</Typography>
                                <Typography variant="body1" color="white">{role}</Typography>
                            </Box>
                        )}
                        {duration && (
                            <Box>
                                <Typography variant="caption" color="rgba(255,255,255,0.7)" display="block">Duration</Typography>
                                <Typography variant="body1" color="white">{duration}</Typography>
                            </Box>
                        )}
                    </Box>
                </Box>
            </Box>
            <Button
                startIcon={<ArrowBackIcon/>}
                onClick={() => navigate('/')}
                sx={{margin: '16px 24px', color: 'text.secondary'}}
            >
                Back to portfolio
            </Button>
        </Box>
    );
}

export default ProjectHeader;
